module.exports = __webpack_public_path__ + "img/logo25.68d29ca8.jpg";